import 'braid-design-system/reset';

import { HirerAuthProvider } from '@seek/hirer-auth-react';
import { HirerApolloProvider } from '@seek/hirer-graphql-react';
import { HubbleProvider } from '@seek/hubble';
import type { Locale } from '@seek/melways-sites';
import { VocabProvider } from '@vocab/react';
import { BraidProvider, ToastProvider } from 'braid-design-system';
import seekJobs from 'braid-design-system/themes/seekJobs';
import { StrictMode } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { Outlet } from 'react-router';

import {
  ConfigProvider,
  type ConfigOptions,
} from 'src/app/shared/contexts/configProvider';
import { apolloConfig } from 'src/app/utils/apolloClient';
import { hubble } from 'src/app/v1/analytics/hubble';
import { store } from 'src/app/v1/state/store';
import type { EmployerSiteName } from 'src/types/app';

import { getHirerAuthProviderProps } from './utils/getHirerAuthProviderProps';

export interface AppProps {
  config: ConfigOptions;
  language: Locale;
  site: EmployerSiteName;
}

export const App = ({ config, language }: AppProps) => (
  <StrictMode>
    <BraidProvider theme={seekJobs}>
      <HubbleProvider hubble={hubble}>
        <ToastProvider>
          <HirerAuthProvider {...getHirerAuthProviderProps()}>
            <HirerApolloProvider {...apolloConfig}>
              {/* TO-DO: Redux to be removed in future RTB */}
              <ReduxProvider store={store}>
                <ConfigProvider config={config}>
                  <VocabProvider language={language}>
                    <Outlet />
                  </VocabProvider>
                </ConfigProvider>
              </ReduxProvider>
            </HirerApolloProvider>
          </HirerAuthProvider>
        </ToastProvider>
      </HubbleProvider>
    </BraidProvider>
  </StrictMode>
);
export default App;
